import {
  useTenantApplicationCreate,
  useTenantApplicationGet,
  useTenantApplicationGetSuspense,
  useTenantApplicationUpdate,
  useTenantApplicationUpdateStatus,
} from "@/api/generated/endpoints/api"
import {
  tenantApplicationCreateBody,
  tenantApplicationGetParams,
  tenantApplicationUpdateBody,
  tenantApplicationUpdateStatusBody,
} from "@/api/generated/schemas/api.zod"

export * as TenantApplicationModels from "./models"

export const tenantApplicationApi = {
  // Query Hooks
  useTenantApplicationGet,
  useTenantApplicationGetSuspense,

  // Mutation Hooks
  useTenantApplicationCreate,
  useTenantApplicationUpdate,
  useTenantApplicationUpdateStatus,
}

export const tenantApplicationSchemas = {
  tenantApplicationCreateBody,
  tenantApplicationGetParams,
  tenantApplicationUpdateBody,
  tenantApplicationUpdateStatusBody,
}
